import { useEffect, useState } from "react";
import { Button, colors, Typography } from "@mui/material";
import { Product } from "api";
import ProductTile from "components/ProductTile/ProductTile";
import { Box } from "@mui/material/node_modules/@mui/system";
import { ListAltOutlined } from "@mui/icons-material";
import { useMobileContext } from "context/mobile/mobileContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

export type CartItem = Product & { quantity: number, discardDate?: Date | null };

export function Cart() {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSummaryVisible, setIsSummaryVisible] = useState(false);
  const { cart, addItem, removeItem } = useMobileContext();

  useEffect(() => {
    if (location.pathname.includes('/summary')) {
      setIsSummaryVisible(true);
    } else {
      setIsSummaryVisible(false);
    }
  }, [location]);

  if (!cart?.length) {
    return <></>
  }

  return (
    <>
      <Box sx={{ marginTop: '60px' }} />
      <Box
        boxShadow={6}
        sx={{
          position: 'fixed',
          padding: '14px',
          zIndex: 99,
          background: 'white',
          bottom: 0,
          left: 0,
          right: 0,
          borderTop: `1px solid ${colors.grey[200]}`,
          display: 'flex',
          flexDirection: 'column',
        }}>
        {isSummaryVisible && (
          <Box sx={{
            maxHeight: 'calc(100vh - 50px)',
            overflowY: 'auto',
          }}>
            <Typography variant="h6" component='h2'>
              {intl.formatMessage({ id: 'mobile.heading.summary' })}
            </Typography>
            {cart.map((product, index) => (
              <Box sx={{
                borderTop: index !== 0 ? `1px solid ${colors.grey[200]}` : '0px',
              }}>
                <ProductTile
                  {...product}
                  onAdd={addItem}
                  onRemove={removeItem}
                />
              </Box>
            ))}
          </Box>
        )}

        <Box sx={{
          display: 'flex',
        }}>
          <>
            <Button
              variant="outlined"
              onClick={() => {
                if (isSummaryVisible) {
                  navigate('..');
                } else {
                  navigate('./summary');
                }
              }}
              sx={{ flex: 1, marginRight: '12px' }}
              startIcon={!isSummaryVisible && <ListAltOutlined />}>
              {isSummaryVisible
                ? intl.formatMessage({ id: 'mobile.button.summaryOpen.title' })
                : intl.formatMessage({ id: 'mobile.button.summaryClosed.title' }, {
                  quantity: cart?.length || 0,
                  copies: cart.reduce((acc, { quantity }) => acc + quantity, 0),
                })}
            </Button>
            <Link to={'preview'} style={{ textDecoration: 'none' }}>
              <Button variant="contained">{intl.formatMessage({ id: 'mobile.button.next.title' })}</Button>
            </Link>
          </>
        </Box>
      </Box>
    </>
  )
}
